var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"แก้ไขล็อต-การส่งของ","link_back":_vm.link_back}}),_c('Order_customer_edit_lots')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }